import { appSettingsProductsData } from "@dashboardApi/apis/appSettingsProductsData";

import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdProductsSettingsCreateCacheKeys: AllRouteEndpoints[] = [appSettingsProductsData];
